import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import VueLogger from 'framework/plugins/vue-log';

import appRoot from 'framework/base/app-root.js';
import initVuex from 'framework/vuex';
import initRouter from 'framework/router';
import registry from './registry';


/**
 * Bootstrap the vue root instance
 */
function init() {
    // Init plugins before registry is run because new merge strategies might be applied by plugins.
    Vue.use(Vuex);
    Vue.use(VueRouter);
    Vue.use(VueLogger, { threshold: globals.config.debug ? 'debug' : 'error' });

    return registry().then(() => {
        // Init vuex
        initVuex(appRoot);

        // Init vue-router
        initRouter(appRoot);

        // Instantiate the vue instance
        return new Vue(appRoot);
    });
}

export default init;



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/base/index.js